import React from 'react';

import Image from 'next/image';

import { Box, Button, Flex } from '@brand/components';

interface Props {
  file: string;
  fileIndex: number;
  removeSelectedImage: any;
}

const MultipleImagesLayout = ({
  file,
  fileIndex,
  removeSelectedImage,
}: Props) => {
  return (
    <Flex align="center" direction="column" justify="center" key={file} p={4}>
      <Box borderRadius="lg" h="130px" position="relative" w="130px">
        <Image alt={file} layout="fill" src={file} />
      </Box>
      <Button
        fontSize="14px"
        mt="5px"
        onClick={() => {
          const fileSelectedIndex = fileIndex;
          return removeSelectedImage(fileSelectedIndex);
        }}
        padding="8px 16px"
        size="sm"
        type="button"
        variant="gray"
      >
        Remove file
      </Button>
    </Flex>
  );
};

export default MultipleImagesLayout;
